import '@babel/polyfill'
import 'es6-promise/auto'
import Vue from 'vue'

import BootstrapVue from 'bootstrap-vue'
import moment from 'moment-timezone'
import VueMoment from 'vue-moment'
import VueProgressiveImage from 'vue-progressive-image'
import Icon from 'vue-awesome/components/Icon'

import App from './App'
import router from './router'
import {i18n, initializeLocale} from './i18n'
import {SubHeader} from './components/mixins/header'
import LImage from './components/mixins/l-image'
import AppState from './plugins/appstate'
import Logger from './plugins/logger'
import store from './api/store'

import './bootstrap.scss'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-awesome/icons'
import 'moment/locale/ko'
import 'moment/locale/en-gb'
import 'moment/locale/ja'
import './components/pipes'

import "@/assets/css/style.scss"

document.cookie = 'LMM_WEBMANAGER_VERSION=;Expires=1544485521178;'

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(VueProgressiveImage)
Vue.use(VueMoment, { moment })
if (!process.env.VUE_APP_STANDALONE) {
  /*
  Vue.use(VueFreshchat, { appToken: "606dad03-57f2-44d4-82ac-260f35738449" });
  */
}
Vue.component('icon', Icon)
Vue.component('sub-header', SubHeader)
Vue.component('l-image', LImage)

Vue.config.productionTip = false
Vue.prototype.AppState = AppState
Vue.prototype.$log = Logger

// IndexedDB Storage 초기화 후 앱 시작
store.waitForInitialization()
  .then(() => {
    // IndexedDB 초기화 완료 후 AppState에 저장된 값 로드
    AppState.initializeFromStore(store)

    // store에서 언어 설정 로드
    initializeLocale(store)

    AppState.App = new Vue({
      router,
      i18n,
      render: h => h(App)
    }).$mount('#app')
  })
  .catch(err => {
    console.error('[Main] Storage initialization failed:', err)

    // 초기화 실패해도 앱은 시작 (빈 캐시로 작동)
    AppState.App = new Vue({
      router,
      i18n,
      render: h => h(App)
    }).$mount('#app')
  })
